import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import ValueLink, { Input as ValueLinkInput } from 'sb-valuelink'
import { injectIntl, Message } from 'sb-react-intl'
import { object } from 'common/helpers'
import cx from 'classnames'

import { CircleLoader } from 'components/_new/ui'
import VisuallyHidden from 'components/ui/VisuallyHidden/VisuallyHidden'

import s from './Input.scss'

import eraseImage from './images/erase.svg'


const getUniqueId = ((id) => () => String(++id))(1)

class Input extends Component {

  static propTypes = {
    intl: PropTypes.object, // @injectIntl
    className: PropTypes.string,
    rootClassName: PropTypes.string,
    inputClassName: PropTypes.string,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    placeholder: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    type: PropTypes.string,
    name: PropTypes.string,
    valueLink: PropTypes.object,
    focusOnInit: PropTypes.bool,
    withLoader: PropTypes.bool,
    withEraser: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    transparent: PropTypes.bool,
    onError: PropTypes.func,
  }

  static defaultProps = {
    focusOnInit: false,
    disabled: false,
    readOnly: false,
    required: false,
    transparent: false,
    withEraser: false,
    type: 'text',
  }

  constructor({ id }) {
    super()

    this.inputId = id || `input_${getUniqueId()}`

    this.state = {
      value: '',
    }
  }

  componentDidUpdate({ valueLink: { error: prevError } = {} }) {
    const { valueLink: { error: nextError } = {} } = this.props

    if (nextError && (!prevError || (nextError.id !== prevError.id))) {
      this.handleError(nextError)
    }
  }

  handleError = () => {
    const { onError, valueLink } = this.props

    if (onError && typeof onError === 'function') {
      onError(valueLink.error, valueLink)
    }
  }

  renderLeftPart() {
    const { withLoader } = this.props

    if (withLoader) {
      return (
        <CircleLoader className={s.circleLoader} />
      )
    }

    return null
  }

  eraseValue = () => {
    const { valueLink } = this.props

    // TODO add erasing
  }

  renderCommonParts() {
    const {
      intl, label, placeholder, type, name,
      focusOnInit, disabled, readOnly, required, withEraser,
      valueLink: _valueLink,
      inputClassName: _inputClassName,
      ...rest
    } = this.props

    // TODO this ductape for landings...
    const valueLink = _valueLink || ValueLink.state(this, 'value')

    const value         = valueLink.value // eslint-disable-line
    const valuePresent  = value !== null && value !== undefined && value !== '' && !Number.isNaN(value)

    const inputClassName = cx(s.input, _inputClassName, {
      [s.filled]: valuePresent,
      [s.withEraser]: withEraser,
    })

    let placeholderValue = placeholder
    if (typeof placeholder === 'object') {
      placeholderValue = intl.formatMessage(placeholder)
    }

    const inputElement = React.createElement(ValueLinkInput, {
      ...object.removeKeys(rest, [
        'styles',
        'styleSpecial',
        'rootClassName',
        'withLoader',
        'transparent',
      ]),
      id: this.inputId,
      className: inputClassName,
      placeholder: placeholderValue,
      valueLink,
      disabled: disabled || readOnly,
      required,
      autoFocus: !!focusOnInit,
      name,
      type,
      dir: 'auto',
      autoComplete: 'nope', // hack to remove autoComplete, coz 'off' doesn't work: https://goo.gl/PeZ856
    })

    let labelElement = (
      <Message
        className={s.label}
        tag="label"
        text={label || placeholder}
        htmlFor={this.inputId}
      />
    )

    if (placeholder) {
      labelElement = <VisuallyHidden>{labelElement}</VisuallyHidden>
    }

    return (
      <Fragment>
        {inputElement}
        {labelElement}
        {
          withEraser && (
            <button className={s.eraser} type="button" onClick={this.eraseValue}>
              <img src={eraseImage} alt="" />
            </button>
          )
        }
      </Fragment>
    )
  }

  render() {
    const { rootClassName: _rootClassName, className, disabled, readOnly, hidden, withLoader, transparent, valueLink } = this.props

    const error = valueLink && valueLink.error // eslint-disable-line

    const rootClassName = cx(s.root, _rootClassName, {
      [s.disabled]: disabled || readOnly,
      [s.errored]: error,
      [s.hidden]: hidden,
      [s.withLoader]: withLoader,
      [s.transparent]: transparent,
    })

    const errorNode = (
      <Message
        text={error}
        aria-live="polite"
        role="region"
      />
    )

    return (
      <div className={className}>
        <div className={rootClassName}>
          {this.renderLeftPart()}
          {this.renderCommonParts()}
        </div>
        {
          Boolean(error) && (
            <div className={s.error}>{errorNode}</div>
          )
        }
      </div>
    )
  }
}


export default injectIntl(Input)
